import React from 'react';

function ProductModal({ product, onClose, onAddToCart, inCart }) {
  const stars = Array.from({ length: 5 }, (_, i) => i < Math.round(product.rating));

  return (
    <div className="ecom-modal-overlay" onClick={onClose}>
      <div className="ecom-modal" onClick={(e) => e.stopPropagation()}>
        <button className="ecom-modal-close" onClick={onClose}>&times;</button>
        <div className="ecom-modal-image" style={{ background: product.color + '15' }}>
          <span className="ecom-modal-emoji">{product.image}</span>
          {product.badge && (
            <span className={`ecom-card-badge ${product.badge.toLowerCase().replace(' ', '-')}`}>
              {product.badge}
            </span>
          )}
        </div>
        <div className="ecom-modal-body">
          <span className="ecom-card-category">{product.category}</span>
          <h2 className="ecom-modal-name">{product.name}</h2>
          <div className="ecom-card-rating">
            <div className="ecom-stars">
              {stars.map((filled, i) => (
                <span key={i} className={`ecom-star ${filled ? 'filled' : ''}`}>★</span>
              ))}
            </div>
            <span className="ecom-review-count">{product.rating} ({product.reviews} reviews)</span>
          </div>
          <p className="ecom-modal-desc">{product.description}</p>
          <div className="ecom-modal-price-row">
            <div className="ecom-card-price">
              <span className="ecom-price large">${product.price.toFixed(2)}</span>
              {product.originalPrice && (
                <span className="ecom-original-price">${product.originalPrice.toFixed(2)}</span>
              )}
            </div>
            <button
              className={`ecom-add-btn large ${inCart ? 'in-cart' : ''}`}
              onClick={onAddToCart}
            >
              {inCart ? '✓ Added to Cart' : '🛒 Add to Cart'}
            </button>
          </div>
          <div className="ecom-modal-features">
            <div className="ecom-modal-feature">🚚 Free Shipping</div>
            <div className="ecom-modal-feature">↩️ 30-Day Returns</div>
            <div className="ecom-modal-feature">🔒 Secure Payment</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductModal;
